import React from 'react';
import { diseasedZone, diseaseType } from "../../../util/varibles/constants";
import Icon, { ICON_NAME } from "../../Icon";
import DiseaseStatus from "./DiseaseStatus";
import styles from "./style.module.scss";

interface IProps {
    diseases: any
}

const SiteDisease: React.FC<IProps> = ({ diseases }) => {
    if (!Array.isArray(diseases))
        return null;

    return <div className={styles.wrapper}>
        {!!diseases.length && <Icon icon={ICON_NAME.DISEASE} size='large' />}
        {diseases.map((item: any) => {
            const { site_id, name } = item || {};
            const { cases = [], diseases: subDiseases = [] } = item;
            const { disease: subDisease = null, status = '' } = cases[0] || {};
            let { logo, diseaseNames } = subDiseases.reduce((rs: any, sub: any, index: number) => {
                const { shortName = '', color = '' } = diseasedZone[sub.type] || {};
                if (color.length > 0) {
                    const style: any = { '--diseased-color': color };
                    rs.logo.push(<div key={index} className={styles.disease} style={style} />);
                }

                rs.diseaseNames.push(shortName);
                return rs;
            }, { logo: [], diseaseNames: [] })

            if (subDisease) {
                const { name: typeName } = diseaseType[subDisease];
                diseaseNames.push(`${typeName} ${status}`);
            }

            if (logo.length === 0 && diseaseNames.length === 0 && !subDisease)
                return null;

            return <div key={site_id} className={styles.line}>
                {logo.length > 0 && <div className={styles.logo}>{logo}</div>}
                {subDisease && <div className='ml-5'>
                    <DiseaseStatus status={subDisease} />
                </div>}
                {diseaseNames.length > 0 && <div className={styles.name}>
                    {name}:
                </div>}
                <div className={styles.diseases}>
                    {diseaseNames.join(', ')}
                </div>
            </div>
        })}
    </div>
};

export default SiteDisease;
